import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as z from "zod/v4";

export const getAllTeamTotes = {
  name: "getAllTeamTotes" as const,
  input: z.object({}),
  output: z.object({
    totes: z.array(RedoFulfillmentToteSchema),
    toteGroups: z.array(RedoFulfillmentToteGroupSchema),
  }),
};
